var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterNoResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-filter",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes wind{0%{transform:rotate(0deg)}25%{transform:rotate(1deg)}75%{transform:rotate(-1deg)}}svg#freepik_stories-filter:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-81",
    className: "animable",
    style: {
      transformOrigin: "252.055px 379.616px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-81",
    d: "M111.63 449.94c77.55 38.83 203.29 38.83 280.85 0s77.55-101.8 0-140.64-203.3-38.84-280.85 0-77.56 101.8 0 140.64Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "252.055px 379.616px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-81",
    className: "animable",
    style: {
      transformOrigin: "251.51px 377.07px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-81",
    cx: 398.68,
    cy: 378.45,
    rx: 39.61,
    ry: 21.53,
    style: {
      fill: "#e6e6e6",
      transformOrigin: "398.68px 378.45px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-81",
    cx: 104.34,
    cy: 375.69,
    rx: 39.61,
    ry: 21.53,
    style: {
      fill: "#e6e6e6",
      transformOrigin: "104.34px 375.69px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-81",
    className: "animable",
    style: {
      transformOrigin: "251.073px 348.952px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-81",
    className: "animable",
    style: {
      transformOrigin: "71.1264px 346.864px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.78 350.45s-.38-8.73-4.21-15.76-9.46-11.64-15-12.47-10.27 3.94-4.57 7.85 15.92 8.21 19.83 21.61Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "73.5984px 336.902px"
    },
    id: "el7vvywpmeo0t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2jql90v208i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.78 350.45s-.38-8.73-4.21-15.76-9.46-11.64-15-12.47-10.27 3.94-4.57 7.85 15.92 8.21 19.83 21.61Z",
    style: {
      opacity: 0.15,
      transformOrigin: "73.5984px 336.902px"
    },
    className: "animable",
    id: "el59us4n2xchg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.32 348.08h.06a.3.3 0 0 0 .19-.37c-4.82-14.77-15.5-21.55-20.47-23.07a.29.29 0 0 0-.37.2.3.3 0 0 0 .19.37c4.88 1.49 15.34 8.14 20.08 22.68a.29.29 0 0 0 .32.19Z",
    style: {
      fill: "#fff",
      transformOrigin: "75.15px 336.355px"
    },
    id: "el3ygnomlzbu5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.65 346.16c.44 1.24 1.71 1.95 2.89 2.53a6 6 0 0 1 3.05 2.38c1.16 2.38-1.24 5.45 0 7.78a4.19 4.19 0 0 0 2.69 1.82c.89.23 1.82.29 2.73.44a11.59 11.59 0 0 0 1.32 0 5.91 5.91 0 0 1 3.76.67c1.75 1.15 2.14 3.49 3.12 5.34a8.67 8.67 0 0 0 5.86 4.27 6.05 6.05 0 0 0 3.19 0l.18-.1c.12-.12.28-.28.34-.36v-.05c.41-1.17 0-2.44 0-3.67v-.22q.23-2.13.42-4.26.39-3.92.64-7.85c.1-1.7.43-3.55-.17-5.21-.68-1.81-2.65-2-3.28-3.77-.25-.71-.36-1.47-.6-2.18a6.11 6.11 0 0 0-4.94-4c-3.44-.42-6.74 2.16-10.18 1.66a24.06 24.06 0 0 1-2.62-.69c-2.76-.72-6.06-.15-7.8 2.11a3.62 3.62 0 0 0-.6 3.36Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "70.7468px 355.639px"
    },
    id: "elkzyqjbp22tq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.53 365.44a.3.3 0 0 0 .24-.35c-3.52-18.27-22.24-22.19-26.68-22.18a.3.3 0 0 0 0 .59c4.35 0 22.65 3.83 26.09 21.71a.3.3 0 0 0 .35.23Z",
    style: {
      fill: "#fff",
      transformOrigin: "72.3098px 354.178px"
    },
    id: "el8jnfn6qw6fe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.17 354.88a.29.29 0 0 0 .16-.07 15.73 15.73 0 0 1 13.12-2.72.3.3 0 0 0 .35-.23.29.29 0 0 0-.22-.35 16.34 16.34 0 0 0-13.64 2.85.3.3 0 0 0 .23.52Z",
    style: {
      fill: "#fff",
      transformOrigin: "71.8252px 352.972px"
    },
    id: "elclbm0sjs63",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "430.144px 350.098px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.28 357.41c-.06-5.18 3.55-16 8.84-22.74s13.68-11.8 19.71-9.82c5.61 1.84 5.09 9.18-1.63 14.12s-16.84 11.17-19.72 19.6L415.35 369Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "430.477px 346.708px"
    },
    id: "elrmxcmzm8php",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh9rjfkrq3ch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.28 357.41c-.06-5.18 3.55-16 8.84-22.74s13.68-11.8 19.71-9.82c5.61 1.84 5.09 9.18-1.63 14.12s-16.84 11.17-19.72 19.6L415.35 369Z",
    style: {
      opacity: 0.1,
      transformOrigin: "430.477px 346.708px"
    },
    className: "animable",
    id: "elu51iube1zfd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414 364.5a.38.38 0 0 0 .34-.31c3.25-17.72 17.38-32.26 25.9-35.53a.39.39 0 0 0 .22-.49.37.37 0 0 0-.46-.17c-8.69 3.34-23.07 18.12-26.38 36.1a.38.38 0 0 0 .31.44Z",
    style: {
      fill: "#fff",
      transformOrigin: "427.048px 346.257px"
    },
    id: "elllynsuu5lqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.75 375.78c.8-2.92 4.3-7.77 10-11.8 6.31-4.47 14.33-6.58 16.15-10 2.18-4.13-1.33-8-7.85-7.08s-17.91 9.94-19.58 23.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "429.508px 361.272px"
    },
    id: "elpczvf5j3vdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.45 372.74a.38.38 0 0 0 .33-.25c5.23-15.21 16.72-20.66 22.06-21.42a.38.38 0 0 0 .33-.43.38.38 0 0 0-.43-.32c-5.91.84-17.33 6.4-22.68 21.92a.38.38 0 0 0 .23.48.47.47 0 0 0 .16.02Z",
    style: {
      fill: "#fff",
      transformOrigin: "426.607px 361.528px"
    },
    id: "el72gszi0dufa",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-81",
    className: "animable",
    style: {
      transformOrigin: "379.949px 285.845px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-81",
    className: "animable",
    style: {
      transformOrigin: "379.949px 285.845px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349 233.56c1.2 1 2.56 1.5 4.14 3a9.29 9.29 0 0 0 3.66 2.55c1.81.71 3.52.5 8.56-.3 6.16-1 8.82-2 11.47-4.29 3.11-2.66 10.07-10.65 13.43-13.79 3.55-3.33 8.44-2 8.44-2a50.89 50.89 0 0 1-6.7 13.81c-2.69 3.83-7.72 7.5-10 9.39-3.64 3-5.57 4.23-13.57 4.83a82.77 82.77 0 0 1-11.77.46c-1.79-.06-2.9-.07-5.82-.32a17.26 17.26 0 0 1-3.76-.65 14.2 14.2 0 0 1-3.92-1.55 10.58 10.58 0 0 1-3.72-4.19 6.63 6.63 0 0 1-.7-3 4.46 4.46 0 0 1 1.09-2.86 1.31 1.31 0 0 1 .5-.37 1.49 1.49 0 0 1 1.09.24 64 64 0 0 0 5.78 3.06c1.67.65 2.94.87 2.82.53s-1.14-.64-2.18-1.81-1.29-2.81-.62-3.31.56-.42 1.78.57Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "368.72px 232.865px"
    },
    id: "elpxsd6yammj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.11 218.68A9.18 9.18 0 0 0 394 218c-3.11.89-5.6 2.92-8.57 6.11s-8 8.33-8 8.33 2.46 6.24 8 8.46l11.61-10.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "388.77px 229.329px"
    },
    id: "elboy19zmh6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elduhld1g89v9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.11 218.68A9.18 9.18 0 0 0 394 218c-3.11.89-5.6 2.92-8.57 6.11s-8 8.33-8 8.33 2.46 6.24 8 8.46l11.61-10.75Z",
    style: {
      opacity: 0.1,
      transformOrigin: "388.77px 229.329px"
    },
    className: "animable",
    id: "elwbkrg7nn1k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m345.44 234.16 11-6.4a3.8 3.8 0 0 1 3.43 0l10.5 5.43a3.78 3.78 0 0 1 1.72 3l.05 12.74a3.78 3.78 0 0 1-1.7 3l-11 6.4a3.8 3.8 0 0 1-3.43 0l-10.5-5.43a3.81 3.81 0 0 1-1.72-3l-.05-12.73a3.81 3.81 0 0 1 1.7-3.01Z",
    style: {
      fill: "#37474f",
      transformOrigin: "357.94px 243.045px"
    },
    id: "ellga9ej5km3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhbthjzvw4do"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.09 235.84c-.12-.87-.83-1.19-1.69-.69l-11 6.41a3.62 3.62 0 0 0-1.41 1.7 4 4 0 0 1 .2-.42l-13.93-7.39a3.4 3.4 0 0 1 1.21-1.28l11-6.41a3.78 3.78 0 0 1 3.42 0l10.51 5.43a3.82 3.82 0 0 1 1.69 2.65Z",
    style: {
      fill: "#455a64",
      opacity: 0.4,
      transformOrigin: "358.175px 235.306px"
    },
    className: "animable",
    id: "elu611uwtovrr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.79 249.87a3.81 3.81 0 0 0 1.72 3l10.5 5.43a3.81 3.81 0 0 0 3.14.12c-.81.31-1.42-.14-1.43-1.12l-.05-12.73a3.5 3.5 0 0 1 .5-1.69l-13.93-7.39a3.47 3.47 0 0 0-.5 1.69Z",
    style: {
      fill: "#263238",
      transformOrigin: "351.445px 247.096px"
    },
    id: "elkqfydvdufdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "389.059px 285.845px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7",
      transformOrigin: "413.65px 367.275px"
    },
    id: "elt3sr86t1og",
    className: "animable",
    d: "M410.13 361.25h7.04v12.05h-7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7",
      transformOrigin: "393.995px 358.025px"
    },
    id: "elmfccva2celh",
    className: "animable",
    d: "m397.69 364.28-7.03.24-.36-12.75 7.39-.24v12.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.17 271.26c0 6.72-1.19 45.82-1.19 45.82.17 1.94 2 5.38 2.17 12.34.21 10.11-3.68 37.85-3.68 37.85a9.24 9.24 0 0 1-7.83.16s-3.2-37.61-4.46-47.61c-1.1-8.73-3-32.44-3-32.44l-3.31 28.49a39.91 39.91 0 0 1 .87 11.19c-.33 4.63-1.63 33.27-1.63 33.27a9.61 9.61 0 0 1-8.11.67s-5-40.83-5.05-45.08c-.09-4.84 1.84-54.23 1.84-54.23Z",
    style: {
      fill: "#37474f",
      transformOrigin: "403.053px 314.956px"
    },
    id: "elh5q2z9e76o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.55 221.81a6.48 6.48 0 0 1 3.39 3.53 16.53 16.53 0 0 1 1 6.08v13.79l.2 26c-10.1 5.33-22.95 5.68-33.73-2.19 0 0 .6-33.53.6-39v-.75a12.52 12.52 0 0 1 15.7-11.26l6.38 1.65 6.41 2.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "403.275px 246.341px"
    },
    id: "elsi0y0br0itg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.56 247.68c1.32.81 2.75 1.12 4.52 2.42a9.34 9.34 0 0 0 4 2c1.9.46 16.82-4.59 19.59-6.72 5.62-4.33 10.48-12.49 13.18-15.58 2.23-2.55 4.76-6.39 7.5-6.41 4.54 1.38 3.51 8.13-.29 14.21a56.47 56.47 0 0 1-15.86 15.8c-3.27 2.15-18.35 6-23.36 6.37-1.52.1-2.65.44-5.55.85a12.26 12.26 0 0 1-3.62.2 16 16 0 0 1-4.29-1.31 10.67 10.67 0 0 1-4.27-3.63A6.53 6.53 0 0 1 357 253a4.39 4.39 0 0 1 .68-3 1.19 1.19 0 0 1 .45-.44 1.49 1.49 0 0 1 1.11.08 62.63 62.63 0 0 0 6.14 2.23c1.75.41 3 .45 2.87.13s-1.22-.48-2.41-1.49-1.67-2.6-1.08-3.19.47-.45 1.8.36Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "387.656px 242.132px"
    },
    id: "elvt768gars6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.47,
    cy: 196.15,
    r: 9.67,
    style: {
      fill: "#263238",
      transformOrigin: "397.47px 196.15px"
    },
    id: "el6oljhtk3gyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.19 203s-1.56 7.37-2.19 8.58a3.32 3.32 0 0 1-1.93 1.55l.11-5.18Z",
    style: {
      fill: "#263238",
      transformOrigin: "412.13px 208.065px"
    },
    id: "el4xy5p699xd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.23 192.48a3.62 3.62 0 0 1 3 1.05c1.29 1.32.57 5.45-1 9.5l-2.95.34Z",
    style: {
      fill: "#263238",
      transformOrigin: "413.588px 197.912px"
    },
    id: "eltjvo2rshkkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.36 203.37c.59.35 1.43-.78 2.16-1.55a2.58 2.58 0 0 1 4.31.7c1.21 2.55-1.05 5.93-2.93 6.52-3.23 1-3.72-1.06-3.72-1.06l-.24 12c-4 5.16-15.18 4.72-10.53-.66v-3.55a20.54 20.54 0 0 1-4.36.22c-2.38-.37-3.88-2.25-4.6-4.82-1.16-4.14-1.6-7.47-.61-15.61 1.07-8.91 11.44-9 17-5.48s3.52 13.29 3.52 13.29Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "403.231px 205.765px"
    },
    id: "eldbwqu1xj0qt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.36 204.37c.29 0 1.43-1.88 2.16-2.55 1-.93-.29-9.34-.29-9.34a4 4 0 0 0-1-4.26c-1.4-1.54-3.74-1.71-7.73-2.34-2.09-.33-5.27-.91-7.36-1.3-2.5-.47-4.57-1-6.33.57a4.45 4.45 0 0 0-1.22 5 4.48 4.48 0 0 0 2.5 2.29s1.09 1 4.88 1.43a56.16 56.16 0 0 0 10.5-.2c1.1-.15 1.33.92 1.92 3.83.53 2.5.96 6.85 1.97 6.87Z",
    style: {
      fill: "#263238",
      transformOrigin: "400.588px 194.235px"
    },
    id: "el9srasl5ser7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.22 193.13 3.58-1.92a2 2 0 0 0-2.71-.9 2.14 2.14 0 0 0-.87 2.82Z",
    style: {
      fill: "#263238",
      transformOrigin: "413.898px 191.61px"
    },
    id: "elpcg4oryxhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.42 215.79s5.31-1.07 7.16-2.06a6.1 6.1 0 0 0 2.57-2.54 8.32 8.32 0 0 1-1.46 3c-1.35 1.74-8.27 3-8.27 3Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "404.285px 214.19px"
    },
    id: "el60np9ibq816",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68 202a1.08 1.08 0 0 0 1.06 1.11 1.11 1.11 0 1 0-1.06-1.11Z",
    style: {
      fill: "#263238",
      transformOrigin: "400.79px 202.001px"
    },
    id: "elcazni8o42tl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.81 198 2.27 1.25a1.36 1.36 0 0 0-.53-1.81 1.25 1.25 0 0 0-1.74.56Z",
    style: {
      fill: "#263238",
      transformOrigin: "402.022px 198.266px"
    },
    id: "elsa0keiu7c3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.9 209.39-2.43.92a1.28 1.28 0 0 0 1.65.8 1.36 1.36 0 0 0 .78-1.72Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "398.724px 210.288px"
    },
    id: "eldso06tbevtv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.5 198.91 2.07-1.6a1.26 1.26 0 0 0-1.8-.27 1.37 1.37 0 0 0-.27 1.87Z",
    style: {
      fill: "#263238",
      transformOrigin: "391.408px 197.843px"
    },
    id: "el9syhbc5p8qd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14 201.74a1.07 1.07 0 1 0 1.06-1.11 1.08 1.08 0 0 0-1.06 1.11Z",
    style: {
      fill: "#263238",
      transformOrigin: "392.209px 201.7px"
    },
    id: "ele74idn4otl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f",
      transformOrigin: "394.715px 203.93px"
    },
    id: "el6uz9tx3hfwd",
    className: "animable",
    d: "m396.56 200.73-.35 6.4-3.34-1.14 3.69-5.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.13 369.82v-1c-.67.29-2.24 6.26-5 8.81-2.22 2-5.25 4.36-6 6.62s4.22 3.65 6.29 3.28c2.41-.43 6.59-2.13 7.64-3.7s1.54-3.89 2.39-5.05 2.82-2.44 3.28-3.77a8.66 8.66 0 0 0-.4-3.7c-.33-1.24-.68-2.61-1.11-2.49v.76a5.53 5.53 0 0 1-3.52 1.19c-1.08.04-3.58-.16-3.57-.95Z",
    style: {
      fill: "#263238",
      transformOrigin: "408.917px 378.201px"
    },
    id: "elkqzb8m00lde",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.58 362.35c-.36 0-.66.53-1.47 1.4a15.09 15.09 0 0 1-4.14 3c-2.63 1.32-7.76 3.35-10.08 4.4-1.45.65-1.38 2.4.12 3.4s5.11 1.71 9.45.74c2.37-.53 5.45-2.71 7.4-2.6s5.59.09 7-.9.87-3.11.46-4.93c-.44-2-1-5.08-1.66-4.94v.68c-.84 1.28-5.21 1.8-7.07.86Z",
    style: {
      fill: "#263238",
      transformOrigin: "386.808px 368.833px"
    },
    id: "elipisxpvtve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.21 287.38a26.19 26.19 0 0 1-9.8-5.62s1.89 3.54 7.52 6.83l-.75 24.89Z",
    style: {
      fill: "#263238",
      transformOrigin: "397.31px 297.62px"
    },
    id: "el119samn02jpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.62 221.81c3.35 1.64 4.71 4.14 3.22 9.72-1.34 5-6.47 13.53-10.5 17.71 0 0-6.91-3.27-10.58-7.53 3.64-5.56 5.39-8.84 8.81-13.55s7-6.92 9.05-6.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "408.6px 235.481px"
    },
    id: "elt1zhluv9yl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell2p0vm3nw9o"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "408.6px 235.481px"
    },
    className: "animable",
    id: "elwdqhr7h8ngo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.62 221.81c3.35 1.64 4.71 4.14 3.22 9.72-1.34 5-6.47 13.53-10.5 17.71 0 0-6.91-3.27-10.58-7.53 3.64-5.56 5.39-8.84 8.81-13.55s7-6.92 9.05-6.35Z",
    id: "elfvwwtfcjjmc",
    className: "animable",
    style: {
      transformOrigin: "408.6px 235.481px"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-81",
    className: "animable",
    style: {
      transformOrigin: "112.11px 283.668px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-81",
    className: "animable",
    style: {
      transformOrigin: "112.11px 283.668px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.73 217c3.71 0 7.64-1.06 10.8 3.73s12.41 26.08 12.41 26.08-7.53 4-7.72 3.72-12.87-21.47-12.87-21.47Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "117.335px 233.722px"
    },
    id: "elh5k50ylpzip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61 212.6a15.41 15.41 0 0 1-15.41-15.41v-1.57a13.06 13.06 0 0 1 13.06-13.06H104a13.06 13.06 0 0 1 13 13.06v1.57a15.41 15.41 0 0 1-15.39 15.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "101.6px 197.58px"
    },
    id: "el0g2f3dlbbpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfexh6atxxw"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "101.6px 197.58px"
    },
    className: "animable",
    id: "elt0pnhghfs6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.61 212.6a15.41 15.41 0 0 1-15.41-15.41v-1.57a13.06 13.06 0 0 1 13.06-13.06H104a13.06 13.06 0 0 1 13 13.06v1.57a15.41 15.41 0 0 1-15.39 15.41Z",
    id: "elhlw46ym3p6r",
    className: "animable",
    style: {
      transformOrigin: "101.6px 197.58px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79.61 214.21a7.17 7.17 0 0 0 7.17-7.21v-14.22a7.17 7.17 0 0 0-7.17 7.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "83.195px 203.495px"
    },
    id: "el994eebjvyu5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7vc0d5l4zio"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.61 214.21a7.17 7.17 0 0 0 7.17-7.21v-14.22a7.17 7.17 0 0 0-7.17 7.22Z",
    style: {
      opacity: 0.2,
      transformOrigin: "83.195px 203.495px"
    },
    className: "animable",
    id: "elqawbf7492k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.48 368.8a41.74 41.74 0 0 0 6 5.24 2.5 2.5 0 0 1 .84.87c.28.59.72 2-2 3a10 10 0 0 1-8.31-.8c-2.21-1.38-2.31-4.26-4.4-5.91-1.55-1.22-3.48-1.53-4.73-3.12-.87-1.11-.64-2.58-.19-4.4.5-2 .72-3.5 1.38-3.35l-.1.92c.82 1.31 5.08 1.7 7 .79a77.05 77.05 0 0 0 4.51 6.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "114.41px 369.392px"
    },
    id: "el99dc52f6haf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.35 370.66c-.64-.59-1.27-1.19-1.87-1.85a52.77 52.77 0 0 1-3.48-5.13 8 8 0 0 1-1.49-3.75c0-1.76.13-4.89.13-4.89l-6.32-.42-.31 6.63c-.16 1.51 1.08 2.84 3.28 4.73s5 6.31 7 7.42 3.41 1.07 4.26.51.94-1.06-1.2-3.25Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "113.554px 364.457px"
    },
    id: "el10fujy4daoah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.45 375.11a41.74 41.74 0 0 0 6 5.24 2.59 2.59 0 0 1 .84.87c.28.59.72 2-2 3a10 10 0 0 1-8.32-.8c-2.21-1.38-2.31-4.26-4.39-5.91-1.55-1.21-3.48-1.53-4.73-3.12-.87-1.1-.65-2.58-.19-4.4.49-2 .72-3.5 1.38-3.35l-.11.92c.82 1.31 5.09 1.7 7 .79a79.45 79.45 0 0 0 4.52 6.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "93.3784px 375.703px"
    },
    id: "elxc2eb07itlg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.32 377a32.56 32.56 0 0 1-1.87-1.85A51.56 51.56 0 0 1 93 370a8.86 8.86 0 0 1-1.47-3.81c-.12-1.55 0-4.76 0-4.76h-6.31l-.22 6.12c-.16 1.5 1.08 2.83 3.28 4.72s5 6.32 7 7.43 3.41 1.07 4.26.5.93-1.04-1.22-3.2Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "92.5416px 371.011px"
    },
    id: "ellmx0971e4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.07 259.13c-5.5 12 .76 57.59.76 57.59-.17 1.95-1.89 5-2.09 10.94-.26 7.65 1.1 35.89 1.1 35.89a8 8 0 0 0 7.2.14s6.52-38.33 7.79-48.42c1.11-8.8 3.24-29.49 3.24-29.49l4.38 29.44a28.53 28.53 0 0 0-2.37 9.36c-.15 5.95.73 33.6.73 33.6a16.54 16.54 0 0 0 7.31.25s6.63-37.41 7.26-44.55c.37-4.27-2.82-56.56-2.82-56.56Z",
    style: {
      fill: "#37474f",
      transformOrigin: "101.609px 310.899px"
    },
    id: "el61s0enuenof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.07 285.78 1.79-9.83s7.56-1.56 11-4.79a19.47 19.47 0 0 1-8.93 5.94l-2 8.6 2 25.69Z",
    style: {
      fill: "#263238",
      transformOrigin: "109.465px 291.275px"
    },
    id: "el5ldgo51n1yo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81 217.32c-4.82.67-7.41 1.74-9 6.28a17.66 17.66 0 0 0 .28 10.3l4.22 12.33a66.77 66.77 0 0 0-6.27 12.9c12.34 6.88 28.78 3.22 32.49-1.81.16-1.06-.84-6.22-.54-11.68.32-5.83 1.25-12.53.34-16.13-1.71-6.69-6.38-11.06-11.63-12.47Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "101.379px 239.977px"
    },
    id: "el4ddqnxjrnx3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.93 230.27c-.21 3.17-1.16 11.89-1.16 11.89l4 6.39-4.47-2.32-4-11.59Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "91.535px 239.41px"
    },
    id: "elbd2ru9ri8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.83 188.94c1.67 1 3.73 5.18 3.53 14-.18 7.45-2.59 9.29-3.81 9.82s-3.55.21-5.82-.17V217s3.14 3.66 2.94 5.71-4.54 2.53-7.48.53a18.93 18.93 0 0 1-4.82-5.05v-10.78a2.87 2.87 0 0 1-4.05.39c-2.51-1.67-2.61-5.8-1.15-7.28s4.61-1 5.2 1a17.85 17.85 0 0 0 8.45-2.52 13.57 13.57 0 0 0 7.01-10.06Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "102.796px 206.729px"
    },
    id: "elmsh13eje53g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 201.05a.94.94 0 0 1-.88 1 1 1 0 0 1-.1-1.94.94.94 0 0 1 .98.94Z",
    style: {
      fill: "#263238",
      transformOrigin: "106.155px 201.08px"
    },
    id: "ele1sn8z8hl5t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.28 207.36 2.18.7a1.12 1.12 0 0 1-1.41.78 1.2 1.2 0 0 1-.77-1.48Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "108.345px 208.125px"
    },
    id: "elt5mevhhs0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.72 198.17-1.9-1.32a1.12 1.12 0 0 1 1.58-.32 1.22 1.22 0 0 1 .32 1.64Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "113.864px 197.251px"
    },
    id: "eljbebpnds6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgae76w5td7s"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "113.864px 197.251px"
    },
    className: "animable",
    id: "eltgzjsycvor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.72 198.17-1.9-1.32a1.12 1.12 0 0 1 1.58-.32 1.22 1.22 0 0 1 .32 1.64Z",
    id: "elkivhinbje6o",
    className: "animable",
    style: {
      transformOrigin: "113.864px 197.251px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M114.28 200.37a1 1 0 0 1-.89 1 1 1 0 0 1-1-.93 1 1 0 0 1 .89-1 1 1 0 0 1 1 .93Z",
    style: {
      fill: "#263238",
      transformOrigin: "113.335px 200.405px"
    },
    id: "elb60szdu8k6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f",
      transformOrigin: "111.42px 202.65px"
    },
    id: "eljzflog5jhpj",
    className: "animable",
    d: "m109.86 199.83.15 5.64 2.97-.92-3.12-4.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73 212.57c-2.4-.31-7.33-1.73-8.1-3.68a5.07 5.07 0 0 0 1.73 2.49c1.47 1.26 6.37 2.68 6.37 2.68Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "101.68px 211.475px"
    },
    id: "elq5t7ywblwtk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "128.66px 254.945px"
    },
    id: "eljigtrkagn6",
    className: "animable",
    d: "m145.21 235.72-25.56 6.74-7.54 31.71 24.3-7.05 8.8-31.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrdmiwmtzoc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.07 256.71c.23.65 1.63 2.45 4.61 2.31l.37-1.32Z",
    style: {
      opacity: 0.1,
      transformOrigin: "136.56px 257.869px"
    },
    className: "animable",
    id: "elputo6ntwf0s"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrrerkr30j5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.35 257.7c-.11.85-1.85 2.42-4.78 3.39-3.35 1.12-8.48.53-8.48.53l.46-1.58Z",
    style: {
      opacity: 0.1,
      transformOrigin: "121.72px 259.738px"
    },
    className: "animable",
    id: "el9c6vnc72u2l"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7fnraandptu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.73 240.32.21-1c.11-.54-1.39-.56-3.35-.05l-3.77 1c-2 .51-3.65 1.36-3.77 1.9l-.21 1Z",
    style: {
      opacity: 0.1,
      transformOrigin: "132.393px 241.035px"
    },
    className: "animable",
    id: "elc13o7ao3eqi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 236.64c.07-.34-.54-.42-1.36-.2l-1.49.41s.44-2.1-2.86-1.37a5.21 5.21 0 0 0-4 3.13l-1.59.46c-.88.25-1.67.72-1.78 1.06l-.19.6 13.17-3.46s.02-.27.1-.63Z",
    style: {
      fill: "#37474f",
      transformOrigin: "132.868px 238.028px"
    },
    id: "el71wnhuo9o0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69 237.69c-1.21.29-1.71.45-1.89 1.28s-.29 1.65-.29 1.65l-5.83 1.54s.28-1.2.37-1.67-.11-.75-1-.51l-.08-.37 9.13-2.32Z",
    style: {
      fill: "#37474f",
      transformOrigin: "133.535px 239.725px"
    },
    id: "elhqvx68hfvoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.89 240.41s.09-.44.21-1-1.39-.56-3.35-.05l-3.77 1c-2 .51-3.65 1.36-3.77 1.9l-.21 1Z",
    style: {
      fill: "#37474f",
      transformOrigin: "132.553px 241.122px"
    },
    id: "el8cgsw6l1qg4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.72 255.66 4.66-7.77s20.47 6 22.5 6.15a5.33 5.33 0 0 0 5.07-3.27c.77-2 2.14-1.75 2.14-1.75s-.6 2.53-.8 3.34 4.69 1.47 7.39.56 6.61.41 4.19 4.09-7.14 4.11-10.41 4.11a33.71 33.71 0 0 1-4.09-.28c-1.06-.13-2.12-.24-3.18-.32-6.7-.47-24.43-3.9-27.47-4.86Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "106.674px 254.505px"
    },
    id: "elzc4cfysf9gc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.61 245-1.14 4c-.21.78-3.19 2.2-5.06 2.71s-3.94 1.13-3 3.76c.82 2.42 3.91 3 5.49 2.9s3.73-1.57 4.57-4c1.09-3.1.5-6.4.93-8.21s-.85-2.24-1.79-1.16Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "138.831px 251.398px"
    },
    id: "el6tuh5cyinha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.38 247.89 4.09-15.56s2.36-8.43 0-14.35c0 0-1.94-.69-4.91 1.76s-4.6 8-5.63 12.49-3.15 19.34-2.9 20.88 3 2.49 11.19 4Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "86.2643px 237.5px"
    },
    id: "elytl01n19jqk",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Filter--inject-81",
    className: "animable animator-active",
    style: {
      transformOrigin: "249.754px 219.583px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown,1.5s Infinite linear wind",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.73 290.5c-14.44 0-26.15 6.75-26.15 15.07v36.33c0 8.32 11.71 15.07 26.15 15.07s26.15-6.75 26.15-15.07v-36.33c0-8.32-11.71-15.07-26.15-15.07Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "249.73px 323.735px"
    },
    id: "elpcjgz675oqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73 290.5c-14.44 0-26.15 6.75-26.15 15.07v36.33c0 8.32 11.71 15.07 26.15 15.07s26.15-6.75 26.15-15.07v-36.33c0-8.32-11.71-15.07-26.15-15.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "249.73px 323.735px"
    },
    id: "elw565lm44n5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellooahqwvb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.58 305.57v36.33c0 6.74 7.68 12.44 18.28 14.37V291.2c-10.6 1.92-18.28 7.63-18.28 14.37Z",
    style: {
      opacity: 0.1,
      transformOrigin: "232.72px 323.735px"
    },
    className: "animable",
    id: "eljrc43oes57r"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.86 309.11c.2-.3 72.46-116.54 72.46-116.54s-36.52 23.57-102.57 23.57a260.67 260.67 0 0 1-35.46-2.38c-43.53-6-67.12-21.19-67.12-21.19l72.41 116.52c4.44 7.12 16.26 12.21 30.14 12.21s25.69-5.09 30.13-12.21Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "249.745px 256.935px"
    },
    id: "el47irrdwi63s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.26 222.62-11-14.46c-25.55-6.84-39.13-15.59-39.13-15.59l72.41 116.52c3.57 5.73 11.92 10.14 22.27 11.64Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "194.47px 256.65px"
    },
    id: "elirzap9ez9wk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 101.9c-22.08-12.75-50.17-19.91-79-21.48-37-2-75.11 5.15-103.4 21.49-50.37 29.09-50.36 76.24 0 105.32a154.78 154.78 0 0 0 38.73 15.39c34.59 8.88 74.57 8.53 108.75-1q7.22-2 14.05-4.58c1.9-.71 3.78-1.46 5.62-2.24q3.93-1.65 7.67-3.49c2.6-1.29 5.14-2.63 7.59-4.05 50.32-29.12 50.33-76.26-.01-105.36Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "249.789px 154.563px"
    },
    id: "elcwkyn97fidw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt7egh6y4r9j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.93 80.42c-37-2-75.11 5.15-103.4 21.49-50.37 29.09-50.36 76.24 0 105.32a154.78 154.78 0 0 0 38.73 15.39c-4.81-6.71-8-22.69 1.27-23.68a139.44 139.44 0 0 1-34.31-13.7c-14.48-8.36-24.29-18.33-28.42-28.84-3.51-9-2.69-18 2.46-26.93 5-8.65 14-16.86 25.93-23.78 24.06-13.9 56.74-20.57 89.07-20 0-.03-.73-4.07 8.67-5.27Z",
    style: {
      opacity: 0.1,
      transformOrigin: "191.343px 151.356px"
    },
    className: "animable",
    id: "ellsfz3hgwl3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335 105.67c-22.25-12.84-51.87-19.53-81.77-20-32.33-.55-65 6.12-89.07 20-12 6.92-20.95 15.13-25.93 23.78-5.15 8.89-6 18-2.46 26.93 4.13 10.51 13.94 20.48 28.42 28.84a139.44 139.44 0 0 0 34.31 13.7c4.74 1.25 9.6 2.31 14.55 3.19a203.1 203.1 0 0 0 26.56 2.89q2.76.13 5.52.18c3.05.08 6.13.09 9.18 0a204.59 204.59 0 0 0 30.9-2.92l.35-.06a182.23 182.23 0 0 0 19.44-4.47q6.76-2 13.1-4.45c1.77-.68 3.5-1.41 5.22-2.16 2.05-.91 4.07-1.87 6.05-2.86s3.78-2 5.61-3c12-6.93 21-15.16 26-23.8 11.02-19.18 1.33-40.03-25.98-55.79Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "249.531px 145.441px"
    },
    id: "el6urn8ighxfx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73 167.83c-30.29 0-56.13 10.93-66.36 26.31a156.83 156.83 0 0 0 15.16 4.79c4.74 1.25 9.6 2.31 14.55 3.19a203.1 203.1 0 0 0 26.53 2.88q2.76.13 5.52.18c3.05.08 6.13.09 9.18 0a204.59 204.59 0 0 0 30.9-2.92l.35-.06a183 183 0 0 0 19.44-4.47q5.66-1.65 11-3.66c-10.22-15.34-36-26.24-66.27-26.24Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "249.685px 186.537px"
    },
    id: "elyfrn7ofv5sn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.7,
    cy: 168.84,
    r: 12.33,
    style: {
      fill: "#b0bec5",
      transformOrigin: "280.7px 168.84px"
    },
    id: "elsxum3yakj6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els9hjvnoslwo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.26 173.28c-5.87-4.26-6.35-12.61-1.76-15.62a12.33 12.33 0 1 0 17.5 11.18c-.44 5.94-9.87 8.69-15.74 4.44Z",
    style: {
      opacity: 0.1,
      transformOrigin: "280.67px 169.422px"
    },
    className: "animable",
    id: "elnoig38rxxia"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 323.01,
    cy: 112.94,
    r: 20.68,
    style: {
      fill: "#455a64",
      transformOrigin: "323.01px 112.94px"
    },
    id: "eloqi9evj9lzs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.24 120.38c-9.85-7.14-10.66-21.16-2.95-26.2a20.69 20.69 0 1 0 29.41 18.76c-.79 9.96-16.6 14.57-26.46 7.44Z",
    style: {
      fill: "#37474f",
      transformOrigin: "323.01px 113.906px"
    },
    id: "el2pfzbs60guk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljg7bcl0n99"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 61.86,
    r: 16.22,
    style: {
      fill: "#455a64",
      transformOrigin: "184.9px 61.86px",
      transform: "rotate(-45deg)"
    },
    className: "animable",
    id: "eltyoyqk4hsh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.38 67.69c-7.73-5.59-8.36-16.59-2.32-20.54a16.22 16.22 0 1 0 23.06 14.71c-.62 7.81-13.02 11.43-20.74 5.83Z",
    style: {
      fill: "#37474f",
      transformOrigin: "184.9px 62.6136px"
    },
    id: "eloidvnfvpd1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.49 139.39 8.56-18.61a6.1 6.1 0 0 1 4.49-3.19L195.4 115a6.11 6.11 0 0 1 5 2.3l11.84 16.72a6.1 6.1 0 0 1 .51 5.49l-8.56 18.61a6.12 6.12 0 0 1-4.5 3.19l-18.85 2.56a6.09 6.09 0 0 1-5-2.3L164 144.88a6.07 6.07 0 0 1-.51-5.49Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "188.118px 139.435px"
    },
    id: "elthznbzxd96",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvbbkd2ytf5q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.84 161.6a6.09 6.09 0 0 0 5 2.3l18.85-2.56a6.17 6.17 0 0 0 4.24-2.73c-.77 1.14-2 1.12-2.91-.16l-11.84-16.73a5.52 5.52 0 0 1-.91-2.68l-25.18 3.15a5.6 5.6 0 0 0 .91 2.69Z",
    style: {
      opacity: 0.1,
      transformOrigin: "183.51px 151.472px"
    },
    className: "animable",
    id: "elqcz5wfp7emc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyeynf8rn3wd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.13 117c-1-1-2.2-.79-2.86.65l-8.57 18.62a5.93 5.93 0 0 0-.29 3.54 5.84 5.84 0 0 1-.11-.73l-25.18 3.15a5.54 5.54 0 0 1 .4-2.81l8.56-18.61a6.1 6.1 0 0 1 4.5-3.19l18.85-2.62a6.13 6.13 0 0 1 4.7 2Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "181.606px 128.614px"
    },
    className: "animable",
    id: "el8aofuq6pjjm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m281.28 33.33 17.24-2.19a5.14 5.14 0 0 1 4.3 1.81l10.31 12.42a5.18 5.18 0 0 1 .59 4.63L307 66a5.17 5.17 0 0 1-3.72 2.83L286 71.05a5.17 5.17 0 0 1-4.3-1.81l-10.28-12.42a5.18 5.18 0 0 1-.59-4.63l6.73-16a5.17 5.17 0 0 1 3.72-2.86Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "292.275px 51.0945px"
    },
    id: "el1vtb0hag55p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elobkkg11r4w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.83 52.19a5.18 5.18 0 0 0 .59 4.63l10.31 12.42a5.22 5.22 0 0 0 3.86 1.83c-1.17 0-1.7-.94-1.19-2.17l6.73-16a4.65 4.65 0 0 1 1.52-1.9l-13.57-16.7a4.7 4.7 0 0 0-1.52 1.86Z",
    style: {
      opacity: 0.1,
      transformOrigin: "281.591px 52.685px"
    },
    className: "animable",
    id: "elxnicl1qs39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwyqqr6ml3p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.87 49.64c.31-1.17-.42-1.94-1.75-1.77l-17.25 2.19a5.1 5.1 0 0 0-2.68 1.38c.15-.14.31-.28.48-.41l-13.56-16.71a4.6 4.6 0 0 1 2.2-1l17.23-2.19a5.16 5.16 0 0 1 4.31 1.8l10.31 12.42a5.22 5.22 0 0 1 .71 4.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "296.581px 41.2779px"
    },
    className: "animable",
    id: "el3up33jwm26t"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m240.51 103.56 9.31.16A2.75 2.75 0 0 1 252 105l4.51 7.37a2.78 2.78 0 0 1 0 2.51l-4.79 8a2.78 2.78 0 0 1-2.19 1.21l-9.31-.16a2.75 2.75 0 0 1-2.14-1.29l-4.51-7.37a2.75 2.75 0 0 1 0-2.5l4.79-8a2.76 2.76 0 0 1 2.15-1.21Z",
    style: {
      fill: "#37474f",
      transformOrigin: "245.039px 113.825px"
    },
    id: "eledws9qh8dv5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf1cwarjv2z4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.54 114.71c.25-.6-.07-1.07-.8-1.08l-9.3-.16a2.67 2.67 0 0 0-1.53.53 1.75 1.75 0 0 1 .29-.18l-5.91-9.9a2.62 2.62 0 0 1 1.24-.35l9.3.16A2.79 2.79 0 0 1 252 105l4.51 7.37a2.8 2.8 0 0 1 .03 2.34Z",
    style: {
      fill: "#455a64",
      opacity: 0.4,
      transformOrigin: "248.036px 109.14px"
    },
    className: "animable",
    id: "eli93g6ra7b9i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.53 112.76a2.75 2.75 0 0 0 0 2.5l4.51 7.37a2.76 2.76 0 0 0 1.91 1.26c-.62-.11-.84-.62-.47-1.24l4.79-8a2.58 2.58 0 0 1 1-.87l-5.91-9.9a2.58 2.58 0 0 0-1 .87Z",
    style: {
      fill: "#263238",
      transformOrigin: "239.25px 113.885px"
    },
    id: "el5ta9jptaabt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvuj8nc8q2f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 239.59,
    cy: 392.39,
    r: 13.65,
    style: {
      fill: "#b0bec5",
      transformOrigin: "239.59px 392.39px",
      transform: "rotate(-80.78deg)"
    },
    className: "animable",
    id: "elo9fxkt8o6ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc9gim4tw12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.79 397.3c-6.5-4.71-7-14-1.95-17.29a13.65 13.65 0 1 0 19.4 12.38c-.52 6.61-10.95 9.61-17.45 4.91Z",
    style: {
      opacity: 0.1,
      transformOrigin: "239.59px 393.025px"
    },
    className: "animable",
    id: "elxjirtkhkt4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m262.62 365.15 7.07.13a2.11 2.11 0 0 1 1.63 1l3.42 5.61a2.09 2.09 0 0 1 0 1.9l-3.64 6.06a2.1 2.1 0 0 1-1.66.92l-7.07-.12a2.09 2.09 0 0 1-1.63-1l-3.43-5.6a2.12 2.12 0 0 1 0-1.9l3.64-6.07a2.15 2.15 0 0 1 1.67-.93Z",
    style: {
      fill: "#37474f",
      transformOrigin: "266.027px 372.96px"
    },
    id: "elnsxfma69wos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el074k0l97lscm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.79 373.62c.19-.45-.05-.81-.6-.82l-7.07-.12a2 2 0 0 0-1.16.4l.21-.14-4.49-7.52a2.09 2.09 0 0 1 .95-.26l7.07.12a2.11 2.11 0 0 1 1.63 1l3.42 5.6a2.12 2.12 0 0 1 .04 1.74Z",
    style: {
      fill: "#455a64",
      opacity: 0.4,
      transformOrigin: "268.319px 369.39px"
    },
    className: "animable",
    id: "el78if33c8osa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.31 372.14a2.12 2.12 0 0 0 0 1.9l3.43 5.6a2.09 2.09 0 0 0 1.45 1c-.47-.09-.64-.48-.36-.94l3.64-6.06a1.92 1.92 0 0 1 .72-.66l-4.49-7.52a2 2 0 0 0-.72.65Z",
    style: {
      fill: "#263238",
      transformOrigin: "261.638px 373.05px"
    },
    id: "el6o0py6w0fr5",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterNoResult);
export default __webpack_public_path__ + "static/media/filterNoResult.52c802accbc3edec0b6016baa57d6606.svg";
export { ForwardRef as ReactComponent };